import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

export default function NotFound() {
  const { t, link } = useLang();
  return (
    <section className="bg-ink bg-grid-dark min-h-[70vh] flex items-center pt-[100px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <p className="font-display text-7xl font-extrabold text-gradient">404</p>
        <h1 className="mt-6 font-display text-2xl sm:text-3xl font-bold">{t("notFound.title")}</h1>
        <p className="mt-3 text-steel">{t("notFound.sub")}</p>
        <Link
          to={link("/")}
          data-testid="notfound-home"
          className="mt-8 inline-block rounded-full bg-gradient-to-r from-dblue to-electric px-7 py-3.5 text-sm font-semibold transition-transform duration-200 hover:scale-[1.04]"
        >
          {t("notFound.cta")}
        </Link>
      </div>
    </section>
  );
}
